import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Actions can be used to reward players for linking their accounts, joining your Discord guild, Steam group, and more. "),
  /*#__PURE__*/_createElementVNode("span", { class: "high-em" }, "Every time a player is updated, their eligibility is calculated for all actions, after which the corresponding actions are invoked"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_2 = { class: "player__info" }
const _hoisted_3 = { class: "breadcrumbs overflow-container" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Integrations ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "breadcrumbs__slash" }, " / ", -1)
const _hoisted_6 = { class: "breadcrumbs__item" }
const _hoisted_7 = { class: "player__created-date" }
const _hoisted_8 = { class: "dashboard__section" }
const _hoisted_9 = { class: "dashboard__header" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, "Actions", -1)
const _hoisted_11 = { class: "dashboard__header-button-container" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" New Action ")
const _hoisted_13 = { class: "high-em" }
const _hoisted_14 = { class: "table__cell--clickable" }
const _hoisted_15 = { class: "table__cell-button align-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_table_row = _resolveComponent("table-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "breadcrumbs__item",
          to: `/dashboard/${_ctx.$route.params.subdomain}/integrations`
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["to"]),
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.integration?.name) + " (#" + _toDisplayString(_ctx.integration?.id) + ") ", 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_fa_icon, { icon: ['far', 'clock'] }),
        _createTextVNode(" Created " + _toDisplayString(_ctx.formattedDate), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_router_link, {
            class: "dashboard__header-button button--no-bg",
            to: `/dashboard/${_ctx.$route.params.subdomain}/integrations/${_ctx.$route.params.id}/new-action`
          }, {
            default: _withCtx(() => [
              _hoisted_12,
              _createVNode(_component_fa_icon, { icon: ['far', 'plus'] })
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _createElementVNode("table", null, [
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action, index) => {
            return (_openBlock(), _createBlock(_component_table_row, {
              clickable: true,
              key: index,
              onClick: ($event: any) => (_ctx.$router.push(
                `/dashboard/${_ctx.$route.params.subdomain}/integrations/${_ctx.integration?.id}/actions/${action.id}`
              ))
            }, {
              text: _withCtx(() => [
                _createElementVNode("span", _hoisted_13, _toDisplayString(action.name), 1)
              ]),
              buttons: _withCtx(() => [
                _createElementVNode("td", _hoisted_14, [
                  _createElementVNode("button", _hoisted_15, [
                    _createVNode(_component_fa_icon, {
                      class: "high-em text--large",
                      icon: ['far', 'eye']
                    })
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ])
      ])
    ])
  ]))
}